import { render, staticRenderFns } from "./IndexPage.vue?vue&type=template&id=2db7427e&scoped=true&"
import script from "./IndexPage.vue?vue&type=script&lang=ts&"
export * from "./IndexPage.vue?vue&type=script&lang=ts&"
import style0 from "./IndexPage.vue?vue&type=style&index=0&id=2db7427e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2db7427e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/agent/workspace/SPP/deployment/frontend-erp-spp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2db7427e')) {
      api.createRecord('2db7427e', component.options)
    } else {
      api.reload('2db7427e', component.options)
    }
    module.hot.accept("./IndexPage.vue?vue&type=template&id=2db7427e&scoped=true&", function () {
      api.rerender('2db7427e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/sales/internal-contract/contract-uploader/IndexPage.vue"
export default component.exports